import React from "react";

import { alpha, Box, Grid, Paper, useTheme } from "@mui/material";
import ProductTimePatternAnalysis from "./ProductTimePatternAnalysis";
import FoodTypeTimePatternAnalysis from "./FoodTypeTimePatternAnalysis";

export default function ProductsJourney({ startDate, endDate }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box>
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                },
              }}
            >
              <FoodTypeTimePatternAnalysis
                startDate={startDate}
                endDate={endDate}
              />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.background.paper, 0.8),
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
                },
              }}
            >
              <ProductTimePatternAnalysis
                startDate={startDate}
                endDate={endDate}
              />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
